import { Model } from "../libs/model/model";

export class PaymentMethodSingle extends Model {
  id: string = "";
  name: string = "";
  img_url: string = "";
  id_client	: number = 0;
}
